<template>
  <div>
    <div class="post-page">
      <rotate-square6 v-if="this.loading"></rotate-square6>
      <template v-if="!loading">
        <div class="post-page__header">
          <container>
            <h1
              class="post-page__title"
              v-html="post.title.rendered"
              :style="{ color: post.cmb2['pt-post-mb']['pt-post-mb__color'] }"
            ></h1>
          </container>
          <img
            class="post-page__thumb"
            :src="
              post.featured_media
                ? post.cmb2['pt-post-mb']['pt-post-mb__featured']
                : require('@/assets/images/thumb.png')
            "
            alt
          />
        </div>
        <container>
          <div class="post-page__controls">
            <span>Tamanho da fonte: {{ zoom * 10 }}%</span>
            <button class="post-page__zoom" @click="zoomout">-</button>
            <button class="post-page__zoom" @click="zoomin">+</button>
          </div>
          <div
            class="post-page__content"
            :style="{ fontSize: `${zoom}px` }"
            v-html="post.content.rendered"
          ></div>
          <div class="post-page__share">
            <h4 class="post-page__share-title">Compartilhe</h4>
            <a
              :href="`https://www.facebook.com/sharer/sharer.php?u=${url}`"
              class="post-page__share-link"
            >
              <img src="../assets/icons/facebook.svg" alt />
            </a>
            <a
              :href="`https://twitter.com/intent/tweet?url=${url}`"
              class="post-page__share-link"
            >
              <img src="../assets/icons/twitter.svg" alt />
            </a>
            <a
              :href="
                `https://www.linkedin.com/shareArticle?mini=true&url=${url}`
              "
              class="post-page__share-link"
            >
              <img src="../assets/icons/linkedin.svg" alt />
            </a>
            <a :href="`mailto:?body=${url}`" class="post-page__share-link">
              <img src="../assets/icons/mail.svg" alt />
            </a>
            <a
              :href="`https://wa.me/?text=${url}`"
              class="post-page__share-link"
            >
              <img src="../assets/icons/whatsapp.svg" alt />
            </a>
          </div>
          <div class="post-page__relateds">
            <div
              v-for="related in random"
              :key="related.ID"
              class="post-page__related"
            >
              <router-link
                :to="{ name: 'post', params: { slug: related.slug } }"
              >
                <img
                  class="post-page__related-thumb"
                  :src="
                    related._embedded['wp:featuredmedia']
                      ? related._embedded['wp:featuredmedia'][0].media_details
                          .sizes.thumb.source_url
                      : require('@/assets/images/thumb.png')
                  "
                  :alt="related.title.rendered"
                  :title="related.title.rendered"
                />
              </router-link>
              <div class="post-page__related-title">
                <router-link
                  :to="{ name: 'post', params: { slug: related.slug } }"
                >
                  <h3 v-html="related.title.rendered"></h3>
                </router-link>
              </div>
            </div>
          </div>
        </container>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import Container from "@/components/Container";
import RotateSquare6 from "vue-loading-spinner/src/components/RotateSquare6";

export default {
  name: "post",
  components: {
    Container,
    RotateSquare6
  },
  data: () => ({
    zoom: 10,
    loading: true
  }),
  methods: {
    ...mapActions("posts", ["find"]),
    zoomin() {
      if (this.zoom >= 20) return;
      this.zoom++;
    },
    zoomout() {
      if (this.zoom <= 4) return;
      this.zoom--;
    }
  },
  computed: {
    ...mapState("posts", {
      post: "item"
    }),
    ...mapGetters("posts", ["random"]),
    url: () => window.location.href
  },
  async created() {
    // await this.all();

    await this.find({
      slug: this.$route.params.slug
    });

    this.loading = false;
  },
  head: {
    title: {
      inner: "Blog sobre estratégias de comunicação e marketing "
    },

    meta: [
      {
        name: "description",
        content:
          "O Blog da Magor reúne artigos sobre temas relevantes em comunicação e marketing e alguns cases executados pela nossa equipe. Confira!",
        id: "desc"
      },
      {
        name: "og:description",
        content:
          "O Blog da Magor reúne artigos sobre temas relevantes em comunicação e marketing e alguns cases executados pela nossa equipe. Confira!",
        id: "ogdesc"
      },
      {
        name: "keywords",
        content:
          "magor, design, gráfico, digital, propaganda, marketing, talento"
      }
    ]
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/vars";

.post-page {
  padding-bottom: 11.5rem;

  &__header {
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;

    height: 28rem;
    padding: 2.5rem;

    @media (min-width: $min-md) {
      height: 44rem;
    }
  }

  &__title {
    font-size: 3rem;
    font-weight: 900;
    line-height: 1.2;

    position: relative;
    z-index: 2;

    text-align: center;

    @media (min-width: $min-md) {
      font-size: 6rem;
    }
  }

  &__thumb {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    object-fit: cover;
  }

  &__controls {
    font-size: 1.5rem;
    line-height: 2.4;

    display: grid;

    max-width: 73rem;
    margin: 2rem auto;

    text-align: right;

    color: #979797;

    grid-template-columns: auto 3.6rem 3.6rem;

    gap: 1.6rem;
  }

  &__zoom {
    font-size: 1.5rem;
    line-height: 2.4;

    padding: 0;

    color: #979797;
    border: 0;
    border-radius: 1rem;
    background-color: #f5f5f5;
  }

  &__share {
    display: grid;
    align-items: baseline;
    justify-content: center;

    margin: 4.6rem 0;
    padding: 2rem;

    grid-template-columns: repeat(5, auto);

    gap: 1.5rem 2.5rem;

    @media (min-width: $min-md) {
      grid-template-columns: repeat(6, auto);
    }
  }

  &__share-title {
    font-size: 1.5rem;
    line-height: 1.8;

    align-self: center;

    text-align: center;

    color: #737373;

    @media (max-width: $max-sm) {
      grid-column: 1 / -1;
    }
  }

  &__share-list {
    align-items: baseline;

    grid-template-columns: repeat(5, auto);

    gap: 2rem;
  }

  &__relateds {
    display: grid;

    margin: 0 auto;

    grid-template-columns: repeat(2, 1fr);

    gap: 2.5rem;

    @media (min-width: $min-md) {
      grid-template-columns: repeat(4, 1fr);

      gap: 3rem;
    }
  }

  &__related-thumb {
    width: 100%;

    border-radius: 1rem;
  }

  &__related-title {
    * {
      color: #000;
      text-decoration: none;
      font-size: 1.7rem;
      line-height: 1.9rem;
      font-weight: 900;
      margin: 1em 0;
      @media (min-width: $min-md) {
        font-size: 2.5rem;
        line-height: 2.7rem;
      }
    }
  }
}
</style>

<style lang="scss">
@import "../assets/css/vars";

.post-page {
  &__content {
    max-width: 73rem;
    margin: 0 auto;

    p {
      font-size: 1.5em;
      line-height: 1.8;

      margin-bottom: 1em;

      @media (min-width: $min-md) {
        font-size: 2em;
      }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-size: 2em;
      font-weight: 900;
      line-height: 1.4;

      margin-top: 2em;

      @media (min-width: $min-md) {
        font-size: 3em;
      }
    }

    img {
      max-width: 100%;
      height: auto;
    }

    a {
      font-weight: 700;

      text-decoration: none;

      &:link,
      &:visited {
        color: inherit;
      }

      &:hover,
      &:active {
        color: #ff3c3c;
      }
    }
  }
}
</style>
